
import { defineComponent, reactive } from 'vue'

// Components
import TheInput from '@/common/components/UI/TheInput/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// Validation
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default defineComponent({
    components: {
        'the-input': TheInput,
        'the-button': TheButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        failed: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit'],
    setup(props, { emit }) {
        const state = reactive({
            number: null as string | null,
        })

        const rules = { number: { required } }

        const state_form$ = useVuelidate(rules, state)

        const emitSubmit = () => {
            if (props.loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('submit', state.number)
        }

        return { state, state_form$, emitSubmit }
    },
})
